/**
 * The sky's capability gate, and the one place it is written down.
 *
 * WHY IT IS NOT INSIDE WaveField ANY MORE. The test used to live in
 * WaveField.tsx, which meant the decision "this device must never run a shader"
 * was made by a module that only exists once the shader chunk has been fetched,
 * parsed and evaluated. A phone declined the canvas after paying for it. The
 * gate report flagged exactly that, and the fix is not a new rule: it is the
 * same rule, hoisted in front of the lazy() boundary so the landing screen can
 * ask the question before it asks for the chunk.
 *
 * WaveField still calls it too, and that is deliberate rather than redundant.
 * The component has to stay correct when it is mounted by a gallery or a test
 * that has not asked the question, and one exported function is what keeps the
 * two answers from drifting apart.
 *
 * The reasoning behind the individual gates is unchanged and belongs to
 * WaveField's own doctrine: a landing page for a cloud product that is slow on
 * a Thai 4G phone is an argument against itself. A coarse pointer, Save-Data,
 * under 4GB of memory, four cores or fewer, and a reader who asked for no
 * motion all get the CSS still, which is the same picture at zero motion.
 */

function query(feature: string): boolean {
  return typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(feature).matches;
}

/** True when this device must be shown the still sky and never the shader. */
export function skyPrefersStill(): boolean {
  if (typeof window === 'undefined') return true;
  if (query('(prefers-reduced-motion: reduce)')) return true;
  if (query('(pointer: coarse)')) return true;
  const nav = navigator as Navigator & {
    deviceMemory?: number;
    connection?: { saveData?: boolean };
  };
  if (nav.connection?.saveData) return true;
  if ((nav.deviceMemory ?? 8) < 4) return true;
  if ((nav.hardwareConcurrency ?? 8) <= 4) return true;
  return false;
}
